import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomSelect } from '../../commons/CustomSelect';
import { currentYear, firstPaymentHistoryYear } from '../../../constants/configuration';

interface YearSelectProps {
  yearsOptions: string;
  handleYearSelect: (value: string) => void;
  optionText: string;
  startDate: string;
}

export const YearSelect: FC<YearSelectProps> = ({ yearsOptions, handleYearSelect, optionText, startDate }) => {
  const { t } = useTranslation();

  const generatePaymentHistoryYears = (firstYear: number, lastYear: number) => {
    const years: string[] = [];
    for (let i = firstYear; i <= lastYear; i += 1) {
      years.push(`${i}`);
    }
    return years;
  };

  const getYearSelectOptions = () => {
    const startYear = new Date(startDate).getFullYear() || 0;
    const firstYear = firstPaymentHistoryYear > startYear ? firstPaymentHistoryYear : startYear;
    return [
      ...generatePaymentHistoryYears(firstYear, currentYear).map((el) => {
        return { id: el, label: t(optionText, { year: el }) };
      }),
    ].reverse();
  };

  return (
    <CustomSelect
      value={yearsOptions}
      setValue={(e) => handleYearSelect(`${e.target.value}`)}
      items={getYearSelectOptions()}
    />
  );
};
